<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <div class="box">
          <!-- /.box-header -->
          <div class="row">
            <div class="box-body form-center">
              <br />
              <!-- 會員已註銷 - Start -->
              <div v-if="memberInfo.delete_status" class="alert alert-info-bg alert-info-border">
                <span class="text-danger">
                  {{ memberInfo.delete_time }} 會員已註銷
                </span>
              </div>
              <!-- 會員已註銷 - End -->
              <div v-else class="text-right">
                <router-link :to="{path: '/upMember/' + memberInfo.shopper_id}"><button class="btn btn-primary inherit"><i class="fa fa-pencil" aria-hidden="true"></i></button></router-link>
                <br />
              </div>
            </div>
            <div class="box-body form-left">
              <div>
                <div class="input-group ">
                  <span class="input-group-addon">編號</span>
                  <div class="form-control form-info">
                    {{memberInfo.user_no}}
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">ID</span>
                  <div class="form-control form-info">
                    {{memberInfo.shopper_id}}
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">品牌既有會員ID</span>
                  <div class="form-control form-info">
                    {{memberInfo.vendor_custom_user_no}}
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">暱稱</span>
                  <div class="form-control form-info">
                    {{memberInfo.nickname}}
                  </div>
                </div>
                <br />
              </div>
              <div v-if="roleType === 99">
                <div class="input-group">
                  <span class="input-group-addon">登入類型</span>
                  <div class="form-control form-info">
                    <!-- 自建帳號 -->
                    <span v-if="memberInfo.create_account_type == 1"><img class="img-login-type img-round" src="/static/img/icon/phone.svg"></span>
                    <!-- FB 帳號 -->
                    <span v-if="memberInfo.create_account_type == 2"><img class="img-login-type img-round" src="/static/img/icon/fb.png"></span>
                    <!-- Google 帳號 -->
                    <span v-if="memberInfo.create_account_type == 3"><img class="img-login-type img-round" src="/static/img/icon/google.png"></span>
                    <!-- LINE 帳號 -->
                    <span v-if="memberInfo.create_account_type == 4"><img class="img-login-type img-round" style="margin-right: 8px;" src="/static/img/icon/line.png"></span><span v-if="memberInfo.create_account_owner_type == 2 && memberInfo.create_account_type == 4">({{memberInfo.create_account_owner_brand_name}})</span><span v-else-if="memberInfo.create_account_owner_type == 1 && memberInfo.create_account_type == 4">(你訂)</span>
                    <!-- 街口 -->
                    <span v-if="memberInfo.create_account_type == 5"><img class="img-login-type img-round" src="/static/img/icon/jkos.svg"></span>
                    <!-- 車廠 -->
                    <span v-if="memberInfo.create_account_type == 6"><img class="img-login-type img-round" src="/static/img/icon/car.png"></span>
                    <!-- 品牌既有會員 -->
                    <span v-if="memberInfo.create_account_type == 7"><img class="img-login-type img-round" src="/static/img/icon/existing-member.png"></span>
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group ">
                  <span class="input-group-addon">信箱</span>
                  <div class="form-control form-info">
                    {{memberInfo.email || '未填寫'}}
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group ">
                  <span class="input-group-addon">地址</span>
                  <div class="form-control form-info">
                    {{memberInfo.email || '未填寫'}}
                  </div>
                </div>
                <br />
              </div>
            </div>
            <div class="box-body form-right">
              <div v-if="memberInfo.birth">
                <div class="input-group ">
                  <span class="input-group-addon">生日</span>
                  <div class="form-control form-info">
                    {{memberInfo.birth}}
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group ">
                  <span class="input-group-addon">手機</span>
                  <div class="form-control form-info">
                    {{memberInfo.phone}}
                    <span v-if="memberInfo.is_phone_valid == 0" class="label label-danger">未通過</span>
                    <span v-if="memberInfo.is_phone_valid == 1"  class="label label-success">已通過</span>
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group" v-if="roleType === 99">
                  <span class="input-group-addon">停權</span>
                  <div class="form-control form-info">
                    <span v-if="memberInfo.is_suspend == 0" class="label label-success">正常</span>
                    <span v-if="memberInfo.is_suspend == 1"  class="label label-danger">停權</span>
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group" v-if="roleType === 99">
                  <span class="input-group-addon">開通</span>
                  <div class="form-control form-info">
                    <span v-if="memberInfo.is_active == 1" class="label label-success">啟動</span>
                    <span v-if="memberInfo.is_active == 0"  class="label label-danger">未啟動</span>
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group" v-if="roleType === 99">
                  <span class="input-group-addon">每日交易金額上限</span>
                  <div class="form-control form-info">
                    {{memberInfo.daily_trade_limit}} 元
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">建立時間</span>
                  <div class="form-control form-info">
                    {{memberInfo.create_time}}
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">備註</span>
                  <div class="form-control form-info">
                    {{memberInfo.remark}}
                  </div>
                </div>
                <br />
              </div>
            </div>
            <div class="box-body form-center" v-if="getRoleType === 99">
              <hr>
              <br>
              <div class="col-xs-12">
                <div class="form-group inline-block">
                  <select class="form-control h-38" v-model="stateType" @change="getList(1)">
                    <option value="all">== 全部狀態 ==</option>
                    <option value="avail">可使用</option>
                    <option value="used">已使用</option>
                    <option value="invalid">無法使用</option>
                  </select>
                </div>
                <div class="form-group inline-block" v-if="brandBrief.length > 1">
                  <multiselect
                    v-model="brandSelect"
                    :options="brandBrief"
                    :searchable="true"
                    :allow-empty="false"
                    :close-on-select="true"
                    placeholder="== 品牌 =="
                    :show-labels="false"
                    :multiple="false"
                    label="label"
                    track-by="value"
                    @input="changeBrand"
                  >
                  </multiselect>
                </div>
                <div class="form-group inline-block" v-if="brandSelect.value !== 0 && brandSelect.value !== '0' && storeBrief.length > 1">
                  <multiselect
                    v-model="storeSelect"
                    :options="storeBrief"
                    :searchable="true"
                    :allow-empty="false"
                    :close-on-select="true"
                    placeholder="== 門市 =="
                    :show-labels="false"
                    :multiple="false"
                    label="label"
                    track-by="value"
                    @input="getList(1)"
                  >
                  </multiselect>
                </div>
              </div>
              <!--主副帳號的優惠券都顯示-->
              <div v-if="couponShallowList.length">
                <div class="col-xs-12">
                  <div class="col-sm-12 table-responsive p-x-0">
                    <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                      <thead>
                      <tr role="row">
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">優惠券代碼 (ID)</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">名稱</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">狀態</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">有效期限</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">獲得來源</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">獲得時間</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr class="even" role="row" v-for="(coupon, index) in couponShallowList">
                        <td>
                          {{index + 1}}
                        </td>
                        <td>
                          {{coupon.coupon_code}} ({{coupon.coupon_item_id}})
                        </td>
                        <td>{{coupon.name}}</td>
                        <td>
                          <span v-if="coupon.status === 0" class="label label-default">未發行</span>
                          <span v-else-if="coupon.status === 9" class="label label-danger">已刪除</span>
                          <span v-else-if="coupon.status === 20" class="label label-primary">使用中</span>
                          <span v-else-if="coupon.status === 30" class="label label-danger">已使用</span>
                          <span v-else-if="coupon.is_expired" class="label label-danger">已過期</span>
                          <span v-else-if="coupon.is_void" class="label label-danger">已作廢</span>
                          <span v-else-if="coupon.status === 10" class="label label-success">可使用</span>
                        </td>
                        <td>
                          ~ {{getDate(coupon.avail_end_time)}}
                        </td>
                        <td>
                          {{getSourceMethodName(coupon.get_source_method)}}
                        </td>
                        <td>{{coupon.get_time}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="col-xs-12 text-center">
                    <ul class="pagination">
                      <li class="paginate_button" @click="clickEnd('pre')">
                        <a class="c-pointer"><i class="fa fa-step-backward" aria-hidden="true"></i></a>
                      </li>
                      <li class="paginate_button"  @click="clickGroup('left')">
                        <a class="c-pointer"><i class="fa fa-backward" aria-hidden="true"></i></a>
                      </li>
                      <li class="paginate_button" v-for="index in pageAmount" :class="{active: isActive(index)}" @click="clickPage(index)" v-if="pageShow(index)">
                        <a class="c-pointer">{{index}}</a>
                      </li>
                      <li class="paginate_button disabled" v-for="dis in (groupAmount - Math.ceil(pageAmount % 10))" v-if="pageGroup === Math.ceil(pageAmount / groupAmount)">
                        <a class="c-pointer">&nbsp;&nbsp;</a>
                      </li>
                      <li class="paginate_button" @click="clickGroup('right')">
                        <a class="c-pointer"><i class="fa fa-forward" aria-hidden="true"></i></a>
                      </li>
                      <li class="paginate_button" @click="clickEnd('forward')">
                        <a class="c-pointer"><i class="fa fa-step-forward" aria-hidden="true"></i></a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  data () {
    return {
      memberInfo: {},
      roleType: 99,
      couponShallowList: [],
      // page
      count: 20,
      total: 0,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      stateType: 'avail',
      // select
      brandSelect: {
        label: '== 品牌 ==',
        vlaue: 0
      },
      storeSelect: {
        label: '== 門市 ==',
        vlaue: 0
      },
      brandBrief: [],
      storeBrief: []
    }
  },
  methods: {
    getList (index) {
      this.gteCouponSummary(index)
    },
    clickPage (index) {
      this.tableIndex = index
      this.getList(index)
    },
    clickGroup (type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1
        this.tableIndex = this.groupAmount * this.pageGroup
        this.clickPage(this.tableIndex)
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1
        this.clickPage(this.tableIndex)
      }
    },
    clickEnd (type) {
      if (type === 'pre') {
        this.clickPage(1)
        this.pageGroup = 1
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount)
        else this.clickPage(1)
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount)
      }
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    pageShow (index) {
      var num = index / this.groupAmount
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true
      else return false
    },
    getSourceMethodName (method) {
      switch (method) {
        case 'order': return '訂單'
        case 'transfer': return '轉贈'
        case 'register': return '註冊'
        case 'other': return '其他'
      }
    },
    getDate (datetime) {
      return moment(datetime, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
    },
    getMemberById () {
      var self = this
      if (this.$route.params.user_id) {
        var url = '/shopper/' + this.$route.params.user_id
        this.loginType = 99
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            self.memberInfo = response.data.shopper_info
            if (self.getRoleType === 99) self.getList(1)
          }
        })
      }
    },
    gteCouponSummary (index) {
      var self = this
      if (index) this.tableIndex = index
      var data = {
        page: this.tableIndex,
        count: this.count
      }
      var url = '/shopper/' + this.$route.params.user_id + '/couponShallowList?page=' + data.page + '&count=' + data.count
      if (this.stateType) url = url + '&state=' + this.stateType
      if (this.brandSelect.value && !this.storeSelect.value) url = url + '&usage_store_type=2&usage_store_value=' + this.brandSelect.value
      else if (this.storeSelect.value) url = url + '&usage_store_type=3&usage_store_value=' + this.storeSelect.value
      /*
      if (searchSelect === 3 && data.search) url = url + '&nickname=' + data.search
      else if (searchSelect === 2 && data.search) url = url + '&phone=' + data.search
      else if (searchSelect === 1 && data.search) url = url + '&email=' + data.search
      else if (searchSelect === 5 && data.search) url = url + '&user_no=' + data.search
      */
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.total = response.data.meta.total
          self.couponShallowList = response.data.coupon_list
        }
      })
    },
    getBrandMemberById () {
      var self = this
      if (this.$route.params.user_id) {
        var url = '/shopper/' + this.$route.params.user_id + '/basic'
        this.loginType = 99
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            self.memberInfo = response.data.shopper_info
          }
        })
      }
    },
    getBrandBrief () {
      var self = this
      self.brandBrief = [{ label: '== 品牌 ==', vlaue: 0 }]
      var url = '/brand/listBrief?is_delete=0&is_opening=1&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list
          for (let i = 0; i < bList.length; i++) {
            let obj = {label: bList[i].name, value: bList[i].brand_id}
            self.brandBrief.push(obj)
          }
        }
      })
    },
    getStoreBrief (brandId) {
      console.log('getStoreBrief | MemberInfo')
      var self = this
      self.storeBrief = [{ label: '== 門市 ==', vlaue: 0 }]
      var url = '/brand/' + brandId + '/storeListBrief?status=2&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            self.storeBrief.push(obj)
          }
        }
      })
    },
    changeBrand () {
      this.storeSelect = {
        value: 0,
        label: '== 門市 =='
      }
      if (this.brandSelect.value) this.getStoreBrief(this.brandSelect.value)
      this.getList(1)
    }
  },
  created () {
    this.roleType = parseInt(this.getRoleType, 10)
    if (this.roleType === 99) this.getMemberById()
    else if (this.roleType === 30) this.getBrandMemberById()
    this.getBrandBrief()
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    }
  }
}
</script>
<style>
.form-control.form-info {
  border: none;
  border-left: 1px solid #d2d6de;
}
.form-info .label {
  font-size: 15px;
  border-radius: 5px !important;
}
.alert-info-border {
  border: 1px solid #3c8dbc;
}
</style>



// WEBPACK FOOTER //
// MemberInfo.vue?7e63b22e